import React, { useState, useEffect } from 'react';
import '../style/MatchDetails.css';
import { MatchDetailsTable } from '../modules/MatchDetailsTable';
import { getUrlVars } from '../util/util';
import {
  createDateTimeFromBackendDate,
  formatBackendDateTimeEtLocale,
  getCurrentDateMinusDays,
} from '../util/dateUtil';
import { fetchMatch } from '../util/api/requests';
import { forfeitScore } from '../util/forfeitUtil';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getTeamId, isUserAdmin, isUserLoggedIn } from './user/User';
import Form from 'react-bootstrap/Form';

const MatchDetails = () => {
  const [matchData, setMatchData] = useState([]);

  useEffect(() => {
    (async () => {
      const matchId = getUrlVars()['match_id'];
      try {
        const match = await fetchMatch(matchId);
        if (match) {
          setMatchData(match);
        }
      } catch (error) {
        console.error('Failed to load match data:', error);
      }
    })();
  }, []);

  if (!matchData.id) {
    return null;
  }

  const isUserWhoIsInHomeOrAwayTeam = (matchData) => {
    return (
      isUserLoggedIn() &&
      (getTeamId() === matchData.homeTeamId ||
        getTeamId() === matchData.awayTeamId) &&
      createDateTimeFromBackendDate(matchData.matchDateTime) >
        getCurrentDateMinusDays(5)
    );
  };

  const matchAnnulledCheckbox = (isMatchAnnulled) => {
    return (
      <Form.Check
        custom
        type='checkbox'
        label=''
        defaultChecked={isMatchAnnulled}
        readOnly={true}
        disabled
        inline={true}
      />
    );
  };

  return (
    <div>
      <div className='d-flex align-items-end flex-column'>
        <span>Koht: {matchData.location}</span>
        <span>
          Kuupäev: {formatBackendDateTimeEtLocale(matchData.matchDateTime)}
        </span>
        {matchData.isMatchAnnulled && (
          <span>
            Matš annulleeritud:{' '}
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              {matchAnnulledCheckbox(matchData.isMatchAnnulled)}
            </span>
          </span>
        )}
        {matchData.isForfeit && (
          <span>
            Loobumiskaotus{' '}
            <strong>
              {`${
                matchData.forfeitingSide === 'HOME'
                  ? matchData.homeTeamName
                  : matchData.awayTeamName
              }`}
            </strong>
            :{' '}
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              {matchAnnulledCheckbox(matchData.isForfeit)}
            </span>
          </span>
        )}
      </div>
      <div>
        <div className='wrapper'>
          <div className='home_player'>
            <h4>{matchData.homeTeamName}</h4>
          </div>
          <div className='guest_player'>
            <h4>{matchData.awayTeamName}</h4>
          </div>
        </div>
        <MatchDetailsTable matchData={matchData} />
        {matchData.isForfeit ? (
          <>
            <h3>Lõpptulemus</h3>
            <h3>{forfeitScore(matchData)}</h3>
          </>
        ) : matchData.homePoints || matchData.awayPoints ? (
          <>
            <h3>Lõpptulemus</h3>
            <h3>
              {matchData.homePoints} : {matchData.awayPoints}
            </h3>
          </>
        ) : null}
      </div>
      <Link to={`/admin/edit_match?match_id=${getUrlVars()['match_id']}`}>
        {(isUserAdmin() || isUserWhoIsInHomeOrAwayTeam(matchData)) && (
          <Button variant='primary'>Muuda andmeid</Button>
        )}
      </Link>
    </div>
  );
};

export default MatchDetails;
